<template>
  <div class="textInputContainer" :class="{ show: isActive }">
    <form @submit.prevent="$emit('submit')" class="textInput">
      <!--<input
        placeholder="入力してください"
        class="textInput__input"
        type="text"
        v-model="internalValue"
        id="textField1"
      />-->
      <textarea
        placeholder="入力してください"
        class="textInput__input"
        v-model="internalValue"
        :rows="rows"
        maxlength="140"
        id="textField1"
      ></textarea>
      <input
        class="inputNextBtn buttonMini buttonMini--circle buttonPrimary"
        :class="{ 'button--disable': buttonDisable }"
        type="submit"
        value="次へ"
      />
    </form>
  </div>
</template>

<script>
import { isModeDraw, isToolText, isTextInput } from "../../util/StoreUtil";

export default {
  name: "TextInput",
  props: ["text", "tool"],
  data() {
    return {
      rows: 1
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.text;
      },
      set(newVal) {
        if (this.text !== newVal) this.$emit("input", newVal);
      }
    },
    isActive() {
      return isToolText() && isTextInput();
    },
    buttonDisable() {
      return this.internalValue === "";
    }
  },
  watch: {
    internalValue(val) {
      this.rows = val.split(/\r\n|\r|\n/).length;
    }
  }
};
</script>

<style scoped lang="sass">
@import "../../sass/zindex"
@import "../../sass/common"
.textInputContainer
  overflow: hidden
  position: absolute
  z-index: $z_tool_text_input
  width: 100%
  font-family: "arena-font2"
  //font-size: 32px
  left: -5500px
  bottom: 1000px
  text-align: center
  > form
    max-width: 375px
    margin: auto
    @include flexCenter
  &.show
    left: 0
    bottom: 190px
  .buttonMini
    margin-left: 10px
    width: 50px
    height: 50px
    border-radius: 50px
    //display: inline-block
.textInput__input
  display: block
  padding: 0.4em
  @include vw(14)
  width: 280px
  vertical-align: bottom
  border-radius: 5px
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.5)
.inputNextBtn
  font-size: 16px
</style>
